const ONBOARDING_ORGANIZATION_PATH = "/onboarding/organization" as const;
const REGISTER_JOIN_PATH = "/register/join" as const;

export { ONBOARDING_ORGANIZATION_PATH, REGISTER_JOIN_PATH };
